import { alpha, Box, Button, styled, Typography } from '@mui/material';
import { ElementType } from 'react';

export const HeaderBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'nodeColor',
})<{ nodeColor: string }>(({ theme, nodeColor }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  background: `linear-gradient(120deg, ${alpha(nodeColor, theme.palette.mode === 'dark' ? 0.42 : 0.3)} 0%, ${alpha(
    nodeColor,
    0.06,
  )} 55%, transparent 100%)`,
}));

export const IconBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'nodeColor',
})<{ nodeColor: string }>(({ theme, nodeColor }) => ({
  flexShrink: 0,
  width: 52,
  height: 52,
  borderRadius: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: nodeColor,
  color: theme.palette.getContrastText(nodeColor),
  boxShadow: `0 6px 18px ${alpha(nodeColor, 0.5)}`,
  '& svg': { fontSize: 28 },
}));

export const HeaderTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '1.5rem',
  lineHeight: 1.15,
  letterSpacing: '-0.01em',
});

export const HeaderActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  flexShrink: 0,
}));

export const DocsButton = styled(Button)<{
  component?: ElementType;
  href?: string;
  target?: string;
  rel?: string;
}>(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.text.secondary,
  borderRadius: '10px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.06),
  '&:hover': {
    color: theme.palette.text.primary,
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.14),
  },
}));
